/**
 * Formats a date string to a localized short date format (e.g., "Jan 15, 2024")
 */
export function formatDate(dateString: string): string {
  // Parse date parts to avoid timezone conversion issues.
  // When new Date() receives "YYYY-MM-DD", it interprets it as UTC midnight,
  // which displays as the previous day in negative UTC offset timezones.
  // Extract just the date part in case we receive a timestamp (YYYY-MM-DDTHH:MM:SSZ)
  const datePart = dateString.slice(0, 10)
  const [year, month, day] = datePart.split('-').map(Number)
  const date = new Date(year, month - 1, day)
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

/**
 * Formats a time string to a localized time format with timezone (e.g., "2:00 PM")
 * Returns null if timeString is null or undefined
 */
export function formatTime(timeString: string | null, timezone: string): string | null {
  if (!timeString) return null

  const date = new Date(timeString)
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: timezone,
  })
}
